import { Select } from '@shared/components/forms';
import { useCallback, useContext } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import type { Filters } from '../../../hooks/products';
import { FilterWrapper } from './filter-wrapper';

const ANY = '__any__';

const DOH_OPTIONS = [
  { label: 'Any', value: ANY },
  { label: '≤ 0 days', value: '0' },
  { label: '≤ 1 day', value: '1' },
  { label: '≤ 7 days', value: '7' },
  { label: '≤ 14 days', value: '14' },
];

export function DohFilter() {
  const { filters, setFilters } = useContext(ProductTableContext);
  const { maximumDOH } = filters;

  const handleChange = useCallback(
    (next: string) => {
      const value = next === ANY ? undefined : Number(next);
      setFilters((prev: Filters) => ({ ...prev, maximumDOH: value }));
    },
    [setFilters]
  );

  return (
    <FilterWrapper label="DOH">
      <Select<string>
        value={maximumDOH === undefined ? ANY : String(maximumDOH)}
        onChange={handleChange}
        options={DOH_OPTIONS}
      />
    </FilterWrapper>
  );
}
